import Reviews from './reviews';

export default Reviews;
